(function () {
  const questionHandles = document.querySelectorAll(
    ".refurbished-faq--faq-item .question"
  );
  questionHandles.forEach((item) => {
    item.addEventListener("click", handleClick);
  });

  function handleClick() {
    const thisIndex = parseInt(this.parentElement.dataset.index);
    const openedIndex = getOpenedIndex();
    if (openedIndex === thisIndex) return;
    const paddingValues = getPaddingValues();
    closeOpened();
    const parent = this.parentElement;
    const answerContainer = parent.querySelector(".answer-container");
    const scrollHeight = answerContainer.scrollHeight;
    answerContainer.style.height =
      paddingValues.top + paddingValues.bottom + scrollHeight + "px";
    parent.classList.add("opened");
  }

  function getOpenedIndex() {
    const opened = document.querySelector(".refurbished-faq--faq-item.opened");
    return parseInt(opened.dataset.index);
  }

  function getPaddingValues() {
    const opened = document.querySelector(".refurbished-faq--faq-item.opened");
    const answerContainer = opened.querySelector(".answer-container");
    const { paddingTop, paddingBottom } = getComputedStyle(answerContainer);

    return { top: parseInt(paddingTop), bottom: parseInt(paddingBottom) };
  }
  function closeOpened() {
    const opened = document.querySelectorAll(
      ".refurbished-faq--faq-item.opened"
    );
    opened.forEach((item) => {
      item.querySelector(".answer-container").style.height = "0px";
      item.querySelector(".answer-container").style.paddingTop = "0px";
      item.querySelector(".answer-container").style.paddingBottom = "0px";

      setTimeout(() => {
        item.classList.remove("opened");
        item.querySelector(".answer-container").style.paddingTop = "";
        item.querySelector(".answer-container").style.paddingBottom = "";
      }, 200);
    });
  }
})();
